import React, { Component } from "react";
import { Button, Container, Form, Image } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";
import "../Common/Common.css";
import Navbar from "../../components/Navbar/Navbar";

class VerifyOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      pinError:"",
    };
  }

  saveChange = event => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      pin: value,
      pinError:"",
    });
  };

  validate=()=>{
    let isError = false;

    const errmsg = "Please enter the OTP";

    const errors = {
      pinError:"",
    };

    if(this.state.pin===""){
      isError=true;
      errors.pinError=errmsg;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  }

  verifyOTPfunc = () => {
    const validatepin = this.validate();

    if(!validatepin) {
      let data = this.state.pin;
      this.props.verifyOTP(data);
    }
  };

  resendverifyOTP=() =>{
    this.props.resendverifyOTP();
  }

  render() {
    console.log(localStorage.getItem("token"));
    return (
      <div>
        <Navbar></Navbar>
        <Container className="forgotContainer">
          <Card.Title className="forgotcardhead">
            <div>
              <h3 className="forgotpassHead"> Verification Code </h3>
            </div>
          </Card.Title>
          <div className="forgotDiv">
            <div>
              <Image
                className="loginimg"
                src={require("../../assets/img/otpscreen.png")}
              />
            </div>
            <h5 className="frgtpanaccount forgotColor">
              Please enter the OTP sent to your registered mobile number
            </h5>

            <Form className="forgotForm">
              <Row>
                <Col lg={2} md={2} sm={12} xs={12}></Col>
                <Col lg={8} md={8} sm={12} xs={12}>
                  <Form.Group controlId="enterOTP">
                    <Form.Control
                      type="text"
                      value={this.state.pin}
                      autoComplete="off"
                      autoFocus={true}
                      onChange={this.saveChange}
                      placeholder="Enter OTP"
                    />
                    <Button
                        className="alignStyle"
                        variant="link"
                        onClick={this.resendverifyOTP}
                      >
                        Resend OTP
                      </Button>
                    <div className="errStyle"style={{float:"left"}}>{this.state.pinError}</div>
                  </Form.Group>
                </Col>
                <Col lg={2} md={2} sm={12} xs={12}></Col>
              </Row>
            </Form>
            <Button className="forgotpagebtn" size="lg" type="submit" onClick={this.verifyOTPfunc}>
                Submit
            </Button>
          </div>
        </Container>
      </div>
    );
  }
}

export default VerifyOTP;
